<template>
    <div>
      <div style="height: 10px;"></div>
      <div class=" contentWidth">
        <!-- <div>求职反馈</div> -->
        <div class="flex tabs-content">
            <Tabs :list="tabList" @upTabs="upTabs"/>
        </div>
        
        <JobCard :types="2" v-for="item in list" :key="item.id" :datas="item"></JobCard>

        <pagination
            :total="pagination.totalRow"
            v-model="conditions.pageIndex"
            v-if="pagination.totalRow>0 && !loading"
            @change="pageChange">
        </pagination>
        <prompt v-if="list && list.length < 1 && !loading"></prompt>
      </div>
      <div style="height: 20px;"></div>
      
    </div>
  </template>
  
  <script>
  import { mapActions, mapState } from "vuex";
  // import JobCard from './components/jobCard.vue';
  import JobCard from '../job/components/item.vue';
  import Tabs from './components/tabs.vue';
  export default {
    data() {
      return {
        conditions:{
          pageIndex:1,
          pageSize:10,
          state:"0"
        },
        loading:false,
      };
    },
    components:{JobCard,Tabs},
    async created() {
      await this.jobseekerState();
      await this.getList();
    },
    methods: {
      ...mapActions([
        "jobseekerState",//求职反馈的状态
        "getFeedBackList"
      ]),
      async pageChange(e){
        this.conditions.pageIndex = e;
        await this.getList();
      },
      async getList() {
        console.log(12345);
        this.loading = true;
        await this.getFeedBackList({...this.conditions})
        this.loading = false;
      },
      upTabs(id){
        this.conditions.pageIndex = 1;
        this.conditions.state = id;
        this.getList();

      }
    },
  
    computed: {
      ...mapState({
        tabList: state => state.user.jobseekerlist,//求职反馈的状态
        list: state => state.user.febacklist,//求职反馈列表
        pagination: state => state.user.febackPagination 
      }),
    }
  };
  </script>
  
  <style lang="less" scoped>
  @mianColor:#287CF3;
  @whiteColor:#fff;
  @mainFontCol:rgba(0,0,0,0.85);
  @secondfontCol:rgba(0,0,0,0.5);
  @yellowColor:#FF8A16;
  .contentWidth{
    .tabs-content{
        border-bottom: 1px solid #EBEBEB;
        padding-bottom: 8px;
        margin-bottom: 10px;
    }
    /deep/.content{
      width: 1280px;
    }
    /deep/.content-left{
       width: 700px;
    }
    /deep/.content-otherinfo{
      width: 580px;
    }
  }
  
  </style>
  